import { render, staticRenderFns } from "./EditReportCustomComponentFooter.vue?vue&type=template&id=2787d339"
import script from "./EditReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./EditReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports